<template>
    <div id="go-pos-payroll">
        <div class="vx-breadcrumb mb-4">
            <ul class="flex flex-wrap items-center">
                <li class="inline-flex items-end">
                    <router-link to="/after-login"><feather-icon icon="HomeIcon" svgClasses="h-5 w-5 mb-1 mr-1 stroke-current text-primary" /></router-link>
                    <span class="breadcrumb-separator mx-2 mr-1"><feather-icon icon="ChevronsRightIcon" svgClasses="w-4 h-4" /></span>
                </li>
                <li class="inline-flex items-end">
                    <span class="breadcrumb-separator mx-2 mb-1 cur-breadcrumb-color">Payroll</span>
                </li>
            </ul>
        </div>

        <div class="go-pos-payroll">
            <h4 class="font-bold text-2xl mb-6">Payroll Payment</h4>
            <div class="payroll-header">
                <div class="left-header">
                    <vs-dropdown vs-trigger-click class="cursor-pointer view-day-select">
                        <div class="w-full h-full flex align-center justify-between">
                            {{view_by.name}}
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                        </div>
                        <vs-dropdown-menu class="payroll-view-day-select-menu">
                            <vs-dropdown-item v-for="(item, index) in viewList" :key="index" @click="changeView(item)">
                                <div class="flex justify-between" :class="{'text-primary': view_by.value == item.value}">
                                    {{item.name}}
                                    <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="view_by.value == item.value" />
                                </div>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                    <div class="flex align-center date-picker-group">
                        <vs-button color="white" class="leading-none calendar-icon-btn" @click="isOpenCalendar = !isOpenCalendar">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 15px; fill: #626262">
                                <path d="M940.218182 107.054545h-209.454546V46.545455h-65.163636v60.50909H363.054545V46.545455H297.890909v60.50909H83.781818c-18.618182 0-32.581818 13.963636-32.581818 32.581819v805.236363c0 18.618182 13.963636 32.581818 32.581818 32.581818h861.090909c18.618182 0 32.581818-13.963636 32.581818-32.581818V139.636364c-4.654545-18.618182-18.618182-32.581818-37.236363-32.581819zM297.890909 172.218182V232.727273h65.163636V172.218182h307.2V232.727273h65.163637V172.218182h176.872727v204.8H116.363636V172.218182h181.527273zM116.363636 912.290909V442.181818h795.927273v470.109091H116.363636z"></path>
                            </svg>
                        </vs-button>
                        <vs-button class="gradient gradient-primary no-shadow today-btn" @click="gotoToday">Today</vs-button>
                        <date-picker class="filter-date-picker" range-separator="  to  " :format="date_format_string" v-model="filter_day" type="date" :editable = "false" :open.sync="isOpenCalendar"
                        @close="isOpenCalendar = false" range placeholder="From date to date" :class="{'width-empty' : filter_day.length == 0, 'width-has-value' : filter_day.length != 0}" @change="filterDay"></date-picker>

                        <vs-button color="white" class="leading-none close-icon-btn" @click="clearDayFilter">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" style="width: 15px; fill: #626262">
                                <path d="M810.005333 274.005333l-237.994667 237.994667 237.994667 237.994667-60.010667 60.010667-237.994667-237.994667-237.994667 237.994667-60.010667-60.010667 237.994667-237.994667-237.994667-237.994667 60.010667-60.010667 237.994667 237.994667 237.994667-237.994667z"></path>
                            </svg>
                        </vs-button>
                    </div>
                </div>

                <div class="right-header">
                    <vs-button color="white" class="setting-btn" @click="popupSettings">
                        <span class="material-icons mr-1">settings</span>
                        Setting
                    </vs-button>

                    <vs-button color="white" class="salary-chart-btn" @click="popupSalaryChart.isOpen = true">
                        <span class="material-icons mr-1">equalizer</span>
                        Salary Chart
                    </vs-button>

                    <vs-button class="gradient gradient-primary no-shadow export-btn" @click="exportPayroll">
                        <div class="flex-center">
                            <img src="../../assets/images/excel.png" class="excel-icon mr-2" />
                            Export
                        </div>
                    </vs-button>
                </div>
            </div>

            <div class="mt-base payroll-body">
                <div class="payroll-left-content">
                    <div class="border-bottom-custom payroll-body-top"></div>
                    <div class="overflow-scroll staff-list" id="pos-payroll-staff-list" v-if="payrollByStaffList && payrollByStaffList.length > 0">
                        <div v-for="(staff, staff_index) in payrollByStaffList" :key="staff_index">
                            <div class="font-bold color-black flex align-center border-bottom-custom bg-white staff-item" v-if="staff.user_id != -1">
                                <vs-avatar :src="staff.image_url" class="border-2 border-solid border-white text-xl staff-avatar" size="35px" 
                                    :text="StringHelper.changeFormatAvatar(staff.name)"
                                    :color="staff.color_code"></vs-avatar>
                                    <div>
                                        <span class="ml-1 mr-2 staff-name">{{staff.name}}</span>
                                        <div class="flex aglin-center text-xs commission-not-available" v-if="!staff.setting_commission">
                                            <feather-icon icon="AlertTriangleIcon" svgClasses="w-3 h-3 stroke-current ml-2 mr-1" />
                                            Commission not available
                                        </div>
                                    </div>
                            </div>
                        </div>

                        <div class="font-bold color-black flex align-center border-bottom-custom bg-white staff-item total-staff" id="pos-total-staff" v-if="payrollByStaffList && payrollByStaffList.length > 0">
                            <span class="ml-1 font-bold text-xl">Total: {{payrollByStaffList.length - 1}} staffs</span>
                        </div>
                    </div>
                    <div class="w-full flex-center p-base" id="pos-payroll-staff-list" v-else>
                        No data available
                    </div>
                </div>

                <div class="payroll-right-content" id="payroll-right-content">
                    <div class="payroll-body-top overflow-hidden" id="payroll-top-body">
                        <div class="h-full flex overflow-x-scroll" id="pos-payroll-date-list" v-if="!isChangeView">
                            <div class="h-full day-grid-col" v-for="(day, index) in day_arr" :key="index"
                                :class="{'week-item': view_by.value == 'week', 'month-item': view_by.value == 'month'}"
                                :id="`payroll-day-${day.isToday ? 'is-today' : index}`">
                                <div class="flex align-center month-row-item border-bottom-custom color-black"
                                    :class="{'border-left-custom': day.day_of_month == 1 && (view_by.value == 'day' || (view_by.value != 'day' && day.month == 'January'))}">
                                    <div class="h-full flex align-center pl-4 bg-white" v-if="(day.day_of_month == 1 || index == 0) && view_by.value == 'day'"
                                        :class="{'month-item-overflow-hidden': index == day_arr.length - 1 || index == day_arr.length - 2}">
                                        <span v-if="index == day_arr.length - 1 || index == day_arr.length - 2">{{getShortMonth(day.month)}}</span>
                                        <span v-else>{{day.month}}/{{day.year}}</span>
                                    </div>
                                    <div class="h-full flex align-center pl-4 bg-white" v-if="(index == 0 && view_by.value != 'day') || (day.month == 'January' && day.day_of_month == 1 && view_by.value != 'day')">
                                        {{day.year}}
                                    </div>
                                </div>
                                <div class="date-item flex-center flex-col text-center position-relative" :class="{'border-left-custom': view_by.value == 'day'}">
                                    <div class="flex-center flex-col text-center bg-white" v-if="view_by.value == 'day'">
                                        <span>{{day.day_of_month}}</span>
                                        <span>{{day.day_of_week}}</span>
                                    </div>
                                    <div class="h-full flex-center flex-col text-center bg-white border-left-custom color-black" style="position: absolute; top: 0; left: 0;" 
                                        :style="`width: calc(${item_width}px * 7);`" v-if="view_by.value == 'week' && day.day_of_week == 'Mon'">
                                        <span class="font-bold">Week {{getCurrentWeekNum(day.full_day)}}</span>
                                        <span>{{getStartDateOfWeek(day.full_day)}} - {{getEndDateOfWeek(day.full_day)}}</span>
                                    </div>
                                    <div class="h-full flex-center flex-col text-center bg-white border-left-custom" style="position: absolute; top: 0; left: 0;" 
                                        :style="`width: calc(${item_width}px * 7);`" v-if="view_by.value == 'month' && day.day_of_month == 1">
                                        <span>{{day.month}}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="height: 100%; width: 8px; min-width: 8px;"></div>
                        </div>
                    </div>
                    <div class="overflow-scroll bg-white salary-list" id="pos-payroll-salary-list" v-if="payrollByStaffList && payrollByStaffList.length > 0 && !isChangeView">
                        <div class="position-relative flex align-center salary-row" v-for="(staff, staff_index) in payrollByStaffList" :key="staff_index">
                            <div class="h-full flex" style="position: absolute; top: 0; left: 0;">
                                <div class="border-left-custom border-bottom-custom day-grid-col" style="z-index: 1; pointer-events: none;" v-for="(day, index) in day_arr" :key="index" :class="{'week-item': view_by.value == 'week', 'month-item': view_by.value == 'month'}" :style="`border-left: 1px solid ${day.day_of_week == 'Mon' ? '#9198a0' : '#e5e5e5'}`"></div>
                            </div>
                            <div class="h-full flex" style="position: absolute; top: 0; left: 0;">
                                <div class="day-grid-col" v-for="(day, index) in day_arr" :key="index + 'a'" style="z-index: 101; pointer-events: none;" :class="{'week-item': view_by.value == 'week', 'month-item': view_by.value == 'month'}">
                                    <div v-if="day.isToday == true" style="width: 2px; height: 100%; background: #FF9F43;" :style="`transform: translateX(${item_width / 2 - 1}px)`"></div>
                                </div>
                            </div>
                            <!-- <div v-if="!isChangeView"> -->
                                <div class="h-full salary-item cursor-pointer" v-for="(payroll, index) in staff.payroll_list" :key="index" style="z-index: 100; position: absolute; top: 0;" 
                                    :style="`width: ${item_width * getItemDuration(index, payroll, staff.payroll_list)}px; min-width: ${item_width * getItemDuration(index, payroll, staff.payroll_list)}px; left: ${item_width * getItemDaysBefore(index, payroll, staff.payroll_list)}px`"
                                    @click="showDetail(staff, payroll)">
                                    <div class="w-full h-full flex-center border-custom rounded-item shadow-md font-bold" :class="{'bg-white': payroll.payroll_id == null, 'custom-grey-item': payroll.payroll_id != null, 'total-salary': staff.user_id == -1}">
                                        ${{+(Math.round(payroll.final_commission + "e+2") + "e-2")}}
                                    </div>
                                </div>
                            <!-- </div> -->
                        </div>
                    </div>
                    <div class="w-full flex-center p-base" id="pos-payroll-salary-list" v-else>
                        No data available
                    </div>
                </div>
            </div>

            <div class="flex justify-center mt-base">
                <vs-button class="gradient gradient-primary create-payroll-btn" @click="createPayroll">Create Payroll</vs-button>
            </div>

            <div class="payroll-detail mt-base" id="payroll-detail" v-if="show_detail">
                <payroll-detail-component :showDetailData="showDetailData" :active_staff="active_staff" :detail_filter_days="detail_filter_days" :key="payroll_detail_key" @ChangeStaffCommission="changeStaffCommission"></payroll-detail-component>
            </div>
        </div>
        <vs-popup-setting-payroll :popupSettingPayroll="popupSettingPayroll" @UpdatePayrollSetting="updatePayrollSetting" @UpdateDiscountSetting="updateDiscountSetting" @UpdateCashDiscountSetting="updateCashDiscountSetting"></vs-popup-setting-payroll>
        <salary-chart-popup :popupSalaryChart="popupSalaryChart"></salary-chart-popup>
        <vs-popup-create-payroll :my_filter="my_filter" :popupCreatePayroll="popupCreatePayroll" @goBack="popupCreatePayroll.isOpen = false" @confirmPayroll="confirmPayroll" :key="create_popup_key"></vs-popup-create-payroll>
        <custom-loading :customLoadingConfig="customLoadingConfig" :isFromApprove="isFromApprove" :key="custom_loading_key + 'custom-loading'"></custom-loading>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import moment from 'moment';
import { StringHelper } from "../../models/string_helper";
import { formatDateString, formatExportDateString } from '../../helper/datetimeHelper';
import FileDownload from'js-file-download';
export default {
    components: {
        DatePicker,
    },
    data() {
        let date_format_string = formatDateString();

        let view_by = {name: 'View day', value: 'day'};
        let day_arr = null;
        let filter_day = [];
        let current_date = new Date();
        filter_day.push(new Date(current_date.getFullYear(), current_date.getMonth(), 1));
        filter_day.push(current_date);

        let start_date = moment().startOf('months').format('MM/DD/YYYY');
        let end_date = moment().format('MM/DD/YYYY');
        this.initData();

        let approve_start_date = moment().format('MM/DD/YYYY');
        let approve_end_date = moment().format('MM/DD/YYYY');
        // let approve_duration = 0;
        let format_export_date_string = formatExportDateString();
        return {
            StringHelper,
            viewList: [
                {name: 'View day', value: 'day'},
                {name: 'View week', value: 'week'},
                {name: 'View month', value: 'month'}
            ],
            view_by,
            filter_day,
            date_format_string,
            isOpenCalendar: false,
            show_detail: false,
            popupSettingPayroll: {
              isOpen: false
            },
            popupSalaryChart: {
              isOpen: false
            },
            popupCreatePayroll: {
              isOpen: false,
              item_info: null
            },
            day_arr,
            my_filter: {
                view_by: {name: 'View day', value: 'day'},
                from_date: moment().startOf('months').format('MM/DD/YYYY'),
                to_date: moment().format('MM/DD/YYYY')
            },
            myWindowWidth: 0,
            rightContentWidth: 0,
            item_width: 50,
            start_date,
            end_date,
            payrollByStaffList: [],
            approve_start_date,
            approve_end_date,
            // approve_duration,
            create_popup_key: 0,
            isOpenLoading: false,
            action_type: '',
            loaded_data_num: 0,
            data_key: 0,
            isChangeView: false,
            showDetailData: null,
            payroll_detail_key: 0,
            active_staff: null,
            // active_type: null,
            detail_filter_days: null,
            format_export_date_string,
            is_change_staff_commission: false,
            customLoadingConfig: {
                isOpen: false
            },
            isFromApprove: false,
            custom_loading_key: 0
        }
    },
    watch: {
        popupSettingPayroll: {
            immediate: true,
            deep: true,
            handler() {
                if(this.popupSettingPayroll.isOpen) {
                    document.body.classList.add('overflow-hidden');
                } else {
                    document.body.classList.remove('overflow-hidden');
                }
            }
        },
        view_by: {
            immediate: true,
            deep: true,
            handler() {
                if(this.view_by) {
                    this.my_filter.view_by = this.view_by;
                }
            }
        },
        my_filter: {
            immediate: true,
            deep: true,
            handler() {
                this.initData();
            }
        },
        rightContentWidth: {
            immediate: true,
            handler() {
                this.initData();
            }
        },
        loaded_data_num: {
            immediate: true,
            handler() {
                if(this.loaded_data_num >= 4) {
                    this.closeLoading();
                } else {
                    this.action_type = "Get data";
                    this.openLoadingInDiv();
                }
            }
        },
        incomeDetail: {
            immediate: true,
            deep: true,
            handler() {
                this.payroll_detail_key++;
                if(this.is_change_staff_commission) {
                    this.getPayrollList();
                }
            }
        }
    },
    methods: {
        getShortMonth(month) {
            return moment().month(month).format('MMM');
        },
        openLoadingInDiv(){
            this.$vs.loading({
                container: '#app',
                scale: 0.8
            })
            if(this.loadTime){
                clearTimeout(this.loadTime);
                this.loadTime = null;
            }
            this.isOpenLoading = true;
            this.loadTime = setTimeout( ()=> {
                if(this.isOpenLoading) {
                this.closeLoading();
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' failed',
                    acceptText: 'OK'
                })
                }
            }, 10000);

        },
        closeLoading() {
            this.$vs.loading.close('#app > .con-vs-loading');
            this.isOpenLoading = false;
        },
        getItemDuration(index, cur_data, list) {
            if(cur_data && list && list.length > 0) {
                // let cur_duration = cur_data.duration;
                let cur_duration = 0;
                if(cur_data.start_date && cur_data.end_date) {
                    cur_duration = moment(cur_data.end_date).diff(cur_data.start_date, 'days') + 1;
                }
                if(list.length == 1) {
                    return cur_duration;
                } else {
                    if((index == 0 && this.compareDays(cur_data.end_date, list[index + 1].start_date)) ||
                       (index == list.length - 1 && this.compareDays(cur_data.start_date, list[index - 1].end_date))) {
                        return cur_duration - 0.5;
                    } else if (index != 0 && index != list.length - 1) {
                        if(this.compareDays(cur_data.end_date, list[index + 1].start_date) && this.compareDays(cur_data.start_date, list[index - 1].end_date)) {
                            return cur_duration - 1;
                        } else if(this.compareDays(cur_data.end_date, list[index + 1].start_date) || this.compareDays(cur_data.start_date, list[index - 1].end_date)) {
                            return cur_duration - 0.5;
                        }
                        return cur_duration;
                    }
                }
                return cur_duration;
            }
        },
        getItemDaysBefore(index, cur_data, list) {
            if(cur_data && list && list.length > 0) {
                // let cur_days_before = cur_data.days_before;
                let cur_days_before = 0;
                if(cur_data.start_date && this.start_date) {
                    cur_days_before = moment(cur_data.start_date).diff(this.start_date, 'days');
                }
                if(list.length == 1 || index == 0) {
                    return cur_days_before;
                } else {
                    if(this.compareDays(cur_data.start_date, list[index - 1].end_date)) {
                        return cur_days_before + 0.5;
                    }
                }
                return cur_days_before;
            }
        },
        compareDays(date1, date2) {
            if(date1 && date2 && moment(date1).format('YYYY-MM-DD') == moment(date2).format('YYYY-MM-DD')) {
                return true;
            }
            return false;
        },
        changeView(item) {
            this.view_by = item;
            // this.data_key++;
            let begin_time = this.$store.getters["goPos/payrollData"].begin_time;
            let end_time = this.$store.getters["goPos/payrollData"].end_time;
            this.getStartEndDateForCalendar(begin_time, end_time);
            // console.log(this.start_date, this.end_date);
            // this.isChangeView = true;
            // setTimeout(() => {
            //     this.isChangeView = false;
            //     this.setDayGridWidth();
            // }, 500);
            this.initData();
        },
        // changeFormat(day) {
        //     return changeFormatHelper(day);
        // },
        // getTime(date) {
        //     return moment(date).format('hh:mm A');
        // },
        popupSettings(){
          this.popupSettingPayroll.isOpen = true;
        },
        onSalaryScroll() {
            let salary_list = document.getElementById('pos-payroll-salary-list');
            let staff_list = document.getElementById('pos-payroll-staff-list');
            let date_list = document.getElementById('pos-payroll-date-list');

            if(salary_list.getAttribute('scrolling') == 'false') {
                staff_list.setAttribute('scrolling', 'true');
                date_list.setAttribute('scrolling', 'true');
            
                staff_list.scrollTop = salary_list.scrollTop;
                date_list.scrollLeft = salary_list.scrollLeft;
            }

            salary_list.setAttribute('scrolling', 'false');
        },
        onStaffScroll() {
            let salary_list = document.getElementById('pos-payroll-salary-list');
            let staff_list = document.getElementById('pos-payroll-staff-list');

            if(staff_list.getAttribute('scrolling') == 'false') {
                salary_list.setAttribute('scrolling', 'true');

                salary_list.scrollTop = staff_list.scrollTop;
            }

            staff_list.setAttribute('scrolling', 'false');
        },
        onDateScroll() {
            let salary_list = document.getElementById('pos-payroll-salary-list');
            let date_list = document.getElementById('pos-payroll-date-list');

            if(date_list.getAttribute('scrolling') == 'false') {
                salary_list.setAttribute('scrolling', 'true');

                salary_list.scrollLeft = date_list.scrollLeft;
            }

            date_list.setAttribute('scrolling', 'false');
        },
        showDetail(staff, payroll) {
            if(payroll && staff && staff.user_id != -1) {
                let data = {
                    staff_id: staff.user_id,
                    start_date: payroll.start_date,
                    end_date: payroll.end_date
                }
                // console.log(data);
                if(!this.isOpenLoading) {
                    this.openLoadingInDiv();
                }
                this.action_type = "Get payroll detail";
                this.$store.dispatch('goPos/GET_INCOME_DETAIL', data).then(() => {
                    this.showDetailData = data;
                    // if(res && res.employee && res.employee.commission_type) {
                    //     this.active_type = {
                    //         type: res.employee.commission_type
                    //     }
                    // }
                    this.payroll_detail_key++;
                    this.show_detail = true;
                    setTimeout(() => {
                        this.closeLoading();
                        let elem = document.getElementById('payroll-detail');
                        if(elem) {
                            let distance = elem.getBoundingClientRect().top + window.scrollY - 100;
                            window.scrollTo({top: distance, behavior: 'smooth'});
                        }
                    }, 50);
                }).catch((err) => {
                    console.log('Err: ' + err);
                })

                let obj = {
                    staff_id : staff.user_id
                }
                this.$store.dispatch("staffList/LIST_COMMISSION_BY_STAFF", obj).then(() => {
                    this.active_staff = staff;
                    this.detail_filter_days = {
                        start_date: payroll.start_date,
                        end_date: payroll.end_date
                    };
                    this.payroll_detail_key++;
                });
            }
        },
        filterDay() {
            if(this.filter_day && this.filter_day.length > 0) {
                this.my_filter.from_date = this.filter_day[0];
                this.my_filter.to_date = this.filter_day[1];
            } else {
                this.my_filter.from_date = null;
                this.my_filter.to_date = null;
            }
            this.getPayrollList();
        },
        getPayrollList(no_loading = false) {
            let data = {};
            if(this.my_filter.from_date) {
                data.start_date = moment(this.my_filter.from_date).format('MM/DD/YYYY');
            }
            if(this.my_filter.to_date) {
                data.end_date = moment(this.my_filter.to_date).format('MM/DD/YYYY');
            }

            if(!this.isOpenLoading && !no_loading) {
                this.openLoadingInDiv();
            }
            this.action_type = "Get payroll list";
            this.$store.dispatch("goPos/GET_PAYROLL_LIST", data).then(() => {
                let begin_time = this.$store.getters["goPos/payrollData"].begin_time;
                let end_time = this.$store.getters["goPos/payrollData"].end_time;
                this.getStartEndDateForCalendar(begin_time, end_time);
                this.payrollByStaffList = this.$store.getters["goPos/payrollData"].employee_list;
                this.getStartEndDateToApprove(this.payrollByStaffList);
                this.initData();
                this.closeLoading();
                this.is_change_staff_commission = false;
                this.customLoadingConfig.isOpen = false;
            }).catch((err) => {
                console.log('Error: ' + err);
                this.customLoadingConfig.isOpen = false;
                this.$vs.dialog({
                    color: 'danger',
                    title: 'Notification',
                    text: this.action_type + ' failed',
                    acceptText: 'OK'
                })
            });
        },
        clearDayFilter() {
            this.filter_day = [];
            this.my_filter.from_date = null;
            this.my_filter.to_date = null;
            this.getPayrollList();
        },
        getDayArr(from, to) {
            let day_arr = [];
            if(from && to) {
                let from_date = this.getFirstDay(from);
                let to_date = this.getLastDay(to);
                let i = 0;
                while(moment(to_date).isAfter(from_date) == true) {
                    from_date = moment(this.getFirstDay(from)).add(i, 'days');
                    let temp = {
                        index: i,
                        full_day: moment(from_date),
                        day_of_week: moment(from_date).format('ddd'),
                        day_of_month: moment(from_date).format('DD'),
                        month: moment(from_date).format('MMMM'),
                        year: moment(from_date).format('YYYY'),
                        isToday: moment().isSame(from_date, 'day') ? true : false
                    }
                    day_arr.push(temp);
                    i++;
                }
            }
            // console.log(day_arr);
            // this.getWeekArr(from, to);
            // console.log(moment(to).diff(from, 'days') + 1);
            // console.log('length: ' + day_arr.length);
            return day_arr;
        },

        getFirstDay(fromDate) {
            if(this.view_by && this.view_by.value == 'month') {
                return moment(fromDate).startOf('month');
            }
            if(this.view_by && this.view_by.value == 'week') {
                return moment(fromDate).subtract(1, 'days').startOf('week').add(1, 'days');
            }
            return fromDate;
        },
        getLastDay(toDate) {
            if(this.view_by && this.view_by.value == 'month') {
                return moment(toDate).endOf('month').subtract(1, 'days');
            }
            if(this.view_by && this.view_by.value == 'week') {
                return moment(toDate).subtract(1, 'days').endOf('week');
            }
            return toDate;
        },
        initData() {
            if(this.start_date && this.end_date) {
                this.day_arr = this.getDayArr(this.start_date, this.end_date);
                setTimeout(() => {
                    this.setDayGridWidth();
                }, 50);
            }
        },
        onResize() {
            this.myWindowWidth = window.innerWidth;
            if(document.getElementById('payroll-right-content')) {
                this.rightContentWidth = document.getElementById('payroll-right-content').clientWidth;
            }
        },
        setDayGridWidth() {
            let right_content = document.getElementById('payroll-right-content');
            let day_item = document.getElementsByClassName('day-grid-col');

            if(this.view_by.value == 'day') {
                this.item_width = 50;
            } else if(this.view_by.value == 'week') {
                this.item_width = 40;
            } else if(this.view_by.value == 'month') {
                this.item_width = 25;
            }
            
            if(right_content && right_content.clientWidth && day_item && day_item.length) {
                let my_width = (right_content.clientWidth - 8) / this.day_arr.length;
                
                if(this.view_by.value == 'day') {
                    if(my_width > 50) {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = my_width + 'px';
                            day_item[i].style.minWidth = my_width + 'px';
                        }
                        this.item_width = my_width;
                    } else {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = '50px';
                            day_item[i].style.minWidth = '50px';
                        }
                        this.item_width = 50;
                    }
                } else if(this.view_by.value == 'week') {
                    if(my_width > 40) {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = my_width + 'px';
                            day_item[i].style.minWidth = my_width + 'px';
                        }
                        this.item_width = my_width;
                    } else {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = '40px';
                            day_item[i].style.minWidth = '40px';
                        }
                        this.item_width = 40;
                    }
                } else if(this.view_by.value == 'month') {
                    if(my_width > 25) {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = my_width + 'px';
                            day_item[i].style.minWidth = my_width + 'px';
                        }
                        this.item_width = my_width;
                    } else {
                        for(let i = 0; i < day_item.length; i++) {
                            day_item[i].style.width = '25px';
                            day_item[i].style.minWidth = '25px';
                        }
                        this.item_width = 25;
                    }
                }
            }
        },
        getStartDateOfWeek(from_date) {
            return moment(from_date).format(formatDateString());
        },
        getEndDateOfWeek(from_date) {
            return moment(from_date).add(6, 'days').format(formatDateString());
        },
        getCurrentWeekNum(date) {
            return moment(date).format('W');
        },
        gotoToday() {
            let elem = document.getElementById('payroll-day-is-today');
            let parent_elem = document.getElementById('pos-payroll-date-list');
            if(elem && parent_elem) {
                if(moment().diff(moment(this.start_date), 'days') > 0) {
                    parent_elem.scrollLeft = moment().diff(moment(this.start_date), 'days') * this.item_width;
                }
            }
        },
        getStartEndDateToApprove(employee_list) {
            if(employee_list && employee_list.length > 0 && employee_list[0].user_id != -1 && employee_list[0].payroll_list) {
                for(let i = 0; i < employee_list[0].payroll_list.length; i++) {
                    if(employee_list[0].payroll_list[i].payroll_id == null) {
                        this.approve_start_date = moment(employee_list[0].payroll_list[i].start_date).format('YYYY-MM-DD');
                        this.approve_end_date = moment(employee_list[0].payroll_list[i].end_date).format('YYYY-MM-DD');
                        // this.approve_duration = employee_list[0].payroll_list[i].duration;
                        if(moment(this.approve_end_date).isAfter(moment()) == true) {
                            this.approve_end_date = moment().format('YYYY-MM-DD');
                        }
                        // this.approve_duration = moment(this.approve_end_date).diff(this.approve_start_date, 'days') + 1;
                        break;
                    }
                }
            }
        },
        getStartEndDateForCalendar(begin_time, end_time) {
            if(this.view_by && begin_time && end_time) {
                this.start_date = moment(this.getFirstDay(begin_time)).format('YYYY-MM-DD');
                this.end_date = moment(this.getLastDay(end_time)).format('YYYY-MM-DD');
            }
        },
        createPayroll() {
            // if(this.approve_duration > 0) {
            //     this.popupCreatePayroll.item_info = {
            //         start_date: this.approve_start_date,
            //         end_date: this.approve_end_date,
            //         duration: this.approve_duration
            //     }
            //     this.popupCreatePayroll.isOpen = true;
            //     this.create_popup_key++;
            // }
            // let data = {};
            // if(this.my_filter.from_date) {
            //     data.start_date = this.my_filter.from_date;
            // }
            let data = {
                start_date: this.approve_start_date,
                end_date: this.approve_end_date,
            }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = "Get approve payroll data";
            this.$store.dispatch("goPos/GET_APPROVE_PAYROLL", data).then(() => {
                if(this.approvePayrollData && this.approvePayrollData.length > 0) {
                    // this.popupCreatePayroll.item_info = this.approvePayrollData[0];
                    this.approve_start_date = this.approvePayrollData[0].start_date;
                    this.approve_end_date = this.approvePayrollData[0].end_date;
                    this.popupCreatePayroll.isOpen = true;
                    this.create_popup_key++;
                }
                this.closeLoading();
            }).catch((err) => {
                console.log('Err: ' + err);
            })
        },
        confirmPayroll() {
            let data = {
                period: this.payrollSetting.period,
                custom_days: this.payrollSetting.custom_days,
                start_date: moment(this.approve_start_date).format('YYYY-MM-DD'),
                end_date: moment(this.approve_end_date).format('YYYY-MM-DD'),
            }
            this.action_type = "Approve payroll";
            // this.customLoadingConfig.isOpen = true;
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch("goPos/APPROVE_PAYROLL", data).then(() => {
                this.popupCreatePayroll.isOpen = false;
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text: 'Approve payroll success',
                    color: 'success',
                    position:'top-right'});
                this.customLoadingConfig.isOpen = true;
                this.isFromApprove = true;
                this.custom_loading_key++;
                setTimeout(() => {
                    this.getPayrollList(true);
                }, 5000);
            }).catch((err) => {
                console.log('Error: ' + err);
                this.popupCreatePayroll.isOpen = false;
            });
        },
        updatePayrollSetting(data) {
            this.action_type = "Update payroll setting";
            if(!this.isOpenLoading) {
              this.openLoadingInDiv();
            }
            this.$store.dispatch('goPos/UPDATE_PAYROLL_SETTING', data).then(() => {
                this.popupSettingPayroll.isOpen = false;
                // this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text: this.action_type + ' success',
                    color: 'success',
                    position:'top-right'});
                this.action_type = "Get payroll setting";
                this.$store.dispatch("goPos/GET_PAYROLL_SETTING").then(() => {
                    this.closeLoading();
                    this.customLoadingConfig.isOpen = true;
                    this.isFromApprove = false;
                    this.custom_loading_key++;
                    setTimeout(() => {
                        this.getPayrollList(true);
                    }, 5000);
                }).catch((err) => {
                    console.log('Error: ' + err);
                });
            }).catch((err) => {
                console.log('Err: ' + err);
                this.popupSettingPayroll.isOpen = false;
            })
        },
        updateDiscountSetting(data) {
            this.action_type = "Update discount setting";
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch('goPos/UPDATE_DISCOUNT_SETTING', data).then(() => {
                this.popupSettingPayroll.isOpen = false;
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text: this.action_type + ' success',
                    color: 'success',
                    position:'top-right'});
                this.customLoadingConfig.isOpen = true;
                this.isFromApprove = false;
                this.custom_loading_key++;
                setTimeout(() => {
                    this.getPayrollList(true);
                }, 5000);
            }).catch((err) => {
                console.log('Err: ' + err);
                this.popupSettingPayroll.isOpen = false;
            })
        },
        updateCashDiscountSetting(data) {
            this.action_type = "Update cash discount setting";
            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.$store.dispatch('goPos/UPDATE_CASH_DISCOUNT_SETTING', data).then(() => {
                this.popupSettingPayroll.isOpen = false;
                this.closeLoading();
                this.$vs.notify({
                    title:'Notification',
                    text: this.action_type + ' success',
                    color: 'success',
                    position:'top-right'});
                this.customLoadingConfig.isOpen = true;
                this.isFromApprove = false;
                this.custom_loading_key++;
                setTimeout(() => {
                    this.getPayrollList(true);
                }, 5000);
            }).catch((err) => {
                console.log('Err: ' + err);
                this.popupSettingPayroll.isOpen = false;
            })
        },
        exportPayroll() {
            let data = {};
            if(this.my_filter.from_date) {
                data.start_date = moment(this.my_filter.from_date).format('MM/DD/YYYY');
            }
            if(this.my_filter.to_date) {
                data.end_date = moment(this.my_filter.to_date).format('MM/DD/YYYY');
            }

            if(!this.isOpenLoading) {
                this.openLoadingInDiv();
            }
            this.action_type = "Export payroll";
            this.$store.dispatch('goPos/EXPORT_PAYROLL', data).then((res) => {
                FileDownload(res.data, `payroll-${moment().format(this.format_export_date_string)}.xlsx`, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                this.closeLoading();
                this.$vs.notify({
                    title: "Notification",
                    text: "Export Payroll Success",
                    color: "success",
                    position: "top-right"
                });
            })
        },
        changeStaffCommission(data) {
            this.is_change_staff_commission = true;
            this.customLoadingConfig.isOpen = true;
            this.isFromApprove = false;
            this.custom_loading_key++;
            setTimeout(() => {
                this.$store.dispatch('goPos/GET_INCOME_DETAIL', data);
                this.getPayrollList(true);
            }, 5000);
        }
    },
    computed: {
        // day_arr() {
        //     return this.getDayArr(moment({ year: 2020, month: 7, day: 1}).format('YYYY-MM-DD'), moment({ year: 2020, month: 8, day: 25}).format('YYYY-MM-DD'));
        // }
        payrollData() {
            return this.$store.getters["goPos/payrollData"];
        },
        payrollSetting() {
            return this.$store.getters["goPos/payrollSetting"];
        },
        approvePayrollData() {
            return this.$store.getters["goPos/approvePayrollData"];
        },
        incomeDetail() {
            return this.$store.getters["goPos/incomeDetail"];
        }
    },
    mounted() {
        // document.getElementById('pos-payroll-salary-list').addEventListener('scroll', this.onVerticalScroll('pos-payroll-salary-list', 'pos-payroll-staff-list'));
        // document.getElementById('pos-payroll-staff-list').addEventListener('scroll', this.onVerticalScroll('pos-payroll-staff-list', 'pos-payroll-salary-list'));

        let salary_list = document.getElementById('pos-payroll-salary-list');
        let staff_list = document.getElementById('pos-payroll-staff-list');
        let date_list = document.getElementById('pos-payroll-date-list');
        // let month_list = document.getElementById('pos-payroll-month-list');

        if(salary_list && staff_list && date_list) {
            salary_list.setAttribute('scrolling', 'false');
            staff_list.setAttribute('scrolling', 'false');
            date_list.setAttribute('scrolling', 'false');
            // month_list.setAttribute('scrolling', 'false');

            document.getElementById('pos-payroll-salary-list').addEventListener('scroll', this.onSalaryScroll);
            document.getElementById('pos-payroll-staff-list').addEventListener('scroll', this.onStaffScroll);
            document.getElementById('pos-payroll-date-list').addEventListener('scroll', this.onDateScroll);
            // document.getElementById('pos-payroll-month-list').addEventListener('scroll', this.onMonthScroll);
        }

        this.$nextTick(() => {
            window.addEventListener("resize", this.onResize);
        }); 
    },
    created() {
        this.action_type = "Get payroll setting";
        this.$store.dispatch("goPos/GET_PAYROLL_SETTING").then(() => {
            this.loaded_data_num++;
            let data = {
                start_date: moment().startOf('months').format('MM/DD/YYYY'),
                end_date: moment().format('MM/DD/YYYY')
            }
            this.action_type = "Get payroll data";
            this.$store.dispatch("goPos/GET_PAYROLL_LIST", data).then(() => {
                // this.start_date = this.$store.getters["goPos/payrollData"].begin_time;
                // this.end_date = this.$store.getters["goPos/payrollData"].end_time;
                let begin_time = this.$store.getters["goPos/payrollData"].begin_time;
                let end_time = this.$store.getters["goPos/payrollData"].end_time;
                this.getStartEndDateForCalendar(begin_time, end_time);
                this.payrollByStaffList = this.$store.getters["goPos/payrollData"].employee_list;
                this.getStartEndDateToApprove(this.payrollByStaffList);
                this.initData();
                this.loaded_data_num++;
            }).catch((err) => {
                console.log('Error: ' + err);
            });
        }).catch((err) => {
            console.log('Error: ' + err);
        });
        this.action_type = "Get discount setting";
        this.$store.dispatch("goPos/GET_DISCOUNT_SETTING").then(() => {
            this.loaded_data_num++;
        }).catch((err) => {
            console.log('Error: ' + err);
        });

        this.action_type = "Get cash discount setting";
        this.$store.dispatch("goPos/GET_CASH_DISCOUNT_SETTING").then(() => {
            this.loaded_data_num++;
        }).catch((err) => {
            console.log('Error: ' + err);
        })
    }
}
</script>
